const React = require('react');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const trim = require('mn-utils/trim');

const {apiAdminMerchantRefundUpdate} = require('../../../../../../../../../api/admin/refunds');
const {openPopupWindow, openV1PopupInfo} = require('../../../../../../../../../emitters/popup');
const isSafeNumber = require('../../../../../../../../../utils/isSafeNumber');
const Popup = require('../../../../../../../../dumb/Popup/C');
const WrapperWithLoading = require('../../../../../../../../dumb/WrapperWithLoading');
const TextField = require('../../../../../../../../dumb/TextField/H');

module.exports = ({id, transactionId, assetAmount, update}) => () => {
  openPopupWindow((setPopupState, popup) => {
    const {
      close,
    } = popup;
    popup.state = {
      transactionId,
      assetAmount,
      clicked: false,
    };

    const changeProvider = changeProviderProvider(setPopupState);
    const handleChangeTransactionId = changeProvider('transactionId');
    const handleChangeAssetAmount = changeProvider('assetAmount');

    return (stateOfPopup) => {
      const {
        transactionId,
        assetAmount,
      } = stateOfPopup;
      const _transactionId = trim(transactionId);
      const _assetAmount = trim(assetAmount);
      let assetAmountHelperText = 'Asset amount is not valid';
      const invalidAssetAmount = !isSafeNumber(_assetAmount);
      if (!_assetAmount) {
        assetAmountHelperText = 'Obligatory field';
      }

      return (
        <Popup
          caption={(
            <div className="layoutRow fhaS fvaC w">
              <div>Edit Refund</div>
              <div className="mh30 fw3 rlv st-2">|</div>
              <div className="f12 fx1 wmin0 tov ov wsNW">{id}</div>
            </div>
          )}
          onCancel={close}
          disabled={stateOfPopup.clicked && invalidAssetAmount}
          onSave={() => {
            if (invalidAssetAmount) {
              setPopupState({
                clicked: true,
              });
              return;
            }

            setPopupState({
              loading: true,
            });

            apiAdminMerchantRefundUpdate({
              id,
              tx_id: _transactionId,
              asset_amount: _assetAmount,
            }).finally((error) => {
              setPopupState({
                loading: false,
              });
              if (error) {
                return;
              }
              update();
              close();
            }).then(() => {
              openV1PopupInfo(['Refund has been changed']);
            });
          }}
        >
          <WrapperWithLoading
            loading={stateOfPopup.loading}
          >
            <TextField
              className="mt20 wmax472"
              label="Transaction ID"
              value={transactionId}
              onChange={handleChangeTransactionId}
            />
            <TextField
              className="mt20 wmax472"
              label="Asset amount"
              value={assetAmount}
              onChange={handleChangeAssetAmount}
              error={stateOfPopup.clicked && invalidAssetAmount}
              helperText={assetAmountHelperText}
            />
          </WrapperWithLoading>
        </Popup>
      );
    };
  });
}
